import api from './axiosInstance';

export const workAssignmentApi = {
  create: data => api.post('/work-assignments', data),
  getByInstance: instanceId => api.get('/work-assignments', {params: {orderLineInstanceId: instanceId}}),
  getByWorker: workerId => api.get('/work-assignments', {params: {workerId}}),
  getAll: (params) => api.get('/work-assignments', {params}),
  update: (id, data) => api.put(`/work-assignments/${id}`, data),
  updateStatus: (id, status) => api.put(`/work-assignments/${id}/status`, {status}),
};
